
import { InvoiceListProps } from "./invoice-list.types";
import { InvoiceListItem } from "./components/invoice-list-item";
import { Suspense } from "react";
const InvoiceList: React.FC<InvoiceListProps> = ({
  invoices,
}) => {

  return <div className="invoice-list flex flex-col gap-2 mt-sm">
    {invoices.map((invoice) => (
      <Suspense key={invoice.id} fallback={<div>Loading...</div>}>
        <InvoiceListItem key={invoice.id} invoice={invoice} />
      </Suspense>
    ))}
  </div>
};

export { InvoiceList };
